/**
 * Strings "Au Quotidien" — structurées pour i18n FR/IT.
 * Ajouter la clé 'it' quand la traduction est disponible.
 */

const CDC_URL = 'https://www.hautemauriennevanoise.fr';

export const t = {
  screenTitle: 'Au Quotidien',
  screenSub: 'Haute Maurienne Vanoise',

  services: {
    title: 'Services publics',
    items: [
      { id: 'etat-civil',  icon: '📋', label: 'État civil',            sub: 'Naissances, mariages, décès',      url: `${CDC_URL}/services` },
      { id: 'urbanisme',   icon: '🏗',  label: 'Urbanisme',             sub: 'Permis de construire, PLU',         url: `${CDC_URL}/services/urbanisme` },
      { id: 'dechets',     icon: '♻️', label: 'Déchets & collecte',    sub: 'Calendrier de collecte',            url: `${CDC_URL}/services/dechets` },
      { id: 'eau',         icon: '💧', label: 'Eau & assainissement',  sub: 'Qualité de l\'eau, réseaux',        url: `${CDC_URL}/services/eau` },
      { id: 'ccas',        icon: '🤝', label: 'CCAS',                  sub: 'Action sociale, familles, seniors', url: `${CDC_URL}/services/action-sociale` },
      { id: 'enfance',     icon: '🎒', label: 'Enfance & périscolaire', sub: 'Crèches, accueil, activités',      url: `${CDC_URL}/services/enfance` },
    ],
  },

  transports: {
    title: 'Transports',
    items: [
      { id: 'navettes', icon: '🎿', label: 'Navettes hivernales',       sub: 'Val-Cenis, Val d\'Isère, Bonneval, Bessans', url: `${CDC_URL}/mobilites/navettes` },
      { id: 'bus',      icon: '🚌', label: 'Bus Modane ↔ Chambéry',     sub: 'Lignes régulières Savoie Mobilité',          url: 'https://www.savoie-mobilite.fr' },
      { id: 'sncf',     icon: '🚂', label: 'Gare SNCF Modane',          sub: 'Liaisons France – Italie (Turin)',            url: 'https://www.sncf-connect.com' },
      { id: 'parking',  icon: '🅿️', label: 'Parkings & P+R',            sub: 'Modane, Lanslebourg, Val-Cenis',             url: `${CDC_URL}/mobilites/parkings` },
    ],
  },

  urgences: {
    title: 'Urgences',
    disclaimer: 'Composez le 112 pour toute urgence vitale',
    highlighted: [
      { id: 'samu',     label: 'SAMU',             number: '15',   tel: '15' },
      { id: 'gend',     label: 'Gendarmerie',      number: '17',   tel: '17' },
      { id: 'pompiers', label: 'Pompiers',          number: '18',   tel: '18' },
      { id: 'eu',       label: 'Urgences EU',       number: '112',  tel: '112' },
      { id: 'sms',      label: 'SMS malentendants', number: '114',  tel: '114' },
    ],
    others: [
      { id: 'pghm',    label: 'PGHM Secours montagne', display: '04 79 08 00 25', tel: '+33479080025' },
      { id: 'pnv',     label: 'Parc national Vanoise',  display: '04 79 62 30 54', tel: '+33479623054' },
      { id: 'hop-mod', label: 'Hôpital Modane',         display: '04 79 05 22 00', tel: '+33479052200' },
      { id: 'hop-sjm', label: 'CH Saint-Jean-de-M.',    display: '04 79 22 38 00', tel: '+33479223800' },
    ],
  },

  institutions: {
    title: 'Infos institutionnelles',
    items: [
      { id: 'cdc',     icon: '🏔', label: 'CdC Haute Maurienne Vanoise', sub: 'Site officiel',                   url: CDC_URL },
      { id: 'mairies', icon: '🏘', label: 'Mairies des 13 communes',     sub: 'Coordonnées et horaires',         url: `${CDC_URL}/communes` },
      { id: 'conseil', icon: '📜', label: 'Conseil communautaire',       sub: 'Délibérations & comptes-rendus', url: `${CDC_URL}/conseil-communautaire` },
      { id: 'marches', icon: '📄', label: 'Marchés publics',             sub: 'Appels d\'offres en cours',      url: `${CDC_URL}/marches-publics` },
    ],
  },
} as const;
